import { render, staticRenderFns } from "./PayeeForm.vue?vue&type=template&id=a4c1b8b2&scoped=true&"
import script from "./PayeeForm.vue?vue&type=script&lang=js&"
export * from "./PayeeForm.vue?vue&type=script&lang=js&"
import style0 from "./PayeeForm.vue?vue&type=style&index=0&id=a4c1b8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c1b8b2",
  null
  
)

component.options.__file = "PayeeForm.vue"
export default component.exports